// extracted by mini-css-extract-plugin
export default {"loginBox":"styles_loginBox__K5yCp","imgBox":"styles_imgBox__FPhD4","formBox":"styles_formBox__hjvT0"};